import { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit({ attributes, setAttributes }) {

    useEffect(() => {

    }, []); // Run once when component mounts

    return (
        <div {...useBlockProps()}>
            <div className={'fsdpe-map-wrapper'}>
            </div>
        </div>
    );
}
